module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-04-f782b4b63535bd7f6c9ad858f5991e70.png";